<script>
    export let logo_url = "";
    export let league = "";
</script>
<div class="py-3 overflow-hidden">
    <div class="px-4 py-5 my-3 text-center animate__animated animate__jackInTheBox">
        <img height="188" width="200" class="d-block mx-auto img-fluid" src="{logo_url}" alt="DFStud's cartoon horse mascot Studly"
            style="max-width: 200px;">
        <div class="col-lg-6 mx-auto p-3 modern-card card">
            <h1 class="display-5 fw-bold">Check Back Later for {league.toUpperCase()} Projections!</h1>
            <p class="lead mb-3">DFStud's {league.toUpperCase()} Projections will be available soon! In the meantime try checking out some other Sports!!</p>
            <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
                {#if league.toUpperCase() == "NBA"}
                <a href="/nfl/optimizer" class="btn btn-primary btn-lg px-4 gap-3">Optimize 🏈 NFL</a>
                <a href="/mlb/optimizer" class="btn btn-outline-secondary btn-lg px-4">Optimize ⚾ MLB</a>
                {:else if league.toUpperCase() == "MLB"}
                <a href="/nfl/optimizer" class="btn btn-primary btn-lg px-4 gap-3">Optimize 🏈 NFL</a>
                <a href="/nba/optimizer" class="btn btn-outline-secondary btn-lg px-4">Optimize 🏀 NBA</a>
                {:else if league.toUpperCase() == "NFL"}
                <a href="/nba/optimizer" class="btn btn-primary btn-lg px-4 gap-3">Optimize 🏀 NBA</a>
                <a href="/mlb/optimizer" class="btn btn-outline-secondary btn-lg px-4">Optimize ⚾ MLB</a>
                {:else if league.toUpperCase() == "NHL"}
                <a href="/nba/optimizer" class="btn btn-primary btn-lg px-4 gap-3">Optimize 🏀 NBA</a>
                <a href="/nfl/optimizer" class="btn btn-outline-secondary btn-lg px-4">Optimize 🏈 NFL</a>
                {/if}
            </div>
        </div>
    </div>
</div>